const RECAPTCHA_COMMON_OPTION = {'sitekey': RECAPTCHA_SITE_KEY, 'theme': 'light'};
let URL_PARAMS = new URLSearchParams(window.location.search);
let user = null;
let loginPhone = $('#login_phone');
window.grecaptchaWidgetId1 = '';
window.grecaptchaWidgetId2 = '';
let access_token, IP_ADDRESS;
let recaptchaLogin = document.getElementById('recaptcha-login');
const modalLoginForm = $('#login-form');
let recaptchaAssistLogin = document.getElementById('recaptcha-assist-login');
const checkShortlistFixedButton = $('#CheckShortlistFixedButton');

window.loginModalElm = $('#loginModal');

window.onloadCallback  = () => {

    if (!!!URL_PARAMS.get('recaptcha_bypass_code')) {

        if (recaptchaLogin) {
            grecaptchaWidgetId1 = grecaptcha.render(recaptchaLogin, {
                ...RECAPTCHA_COMMON_OPTION,
                callback: (token) => phoneLogin(false, token)
            });
        }

        if (recaptchaAssistLogin) {
            grecaptchaWidgetId2 = grecaptcha.render(recaptchaAssistLogin, {
                ...RECAPTCHA_COMMON_OPTION,
                callback: (token) => AssistPhoneLogin(false, token)
            });
        }

    }
}

window.validateFormLogin = (type) => {
    if (type === "submit") {

        if($('#login-form').find('#login-step-1').hasClass('show')) return !!(loginPhone.val());

        if ($("#login-form").find("#login_otp").length > 0)
            return !!(loginPhone.val() && $('#login_name').val() && $('#login_otp').val());
        else
            return !!(loginPhone.val() && $('#login_name').val());
    } else if (type === "resend") return !!(loginPhone.val() && $('#login_name').val());
    else return false;
}

window.phoneLogin = async (background = false, recaptcha_token = null) => {
    let loginStep1 = $('#login-step-1-tab');
    let sendOtpButton = $('#login-step-1').find('.btn-submit');
    let userName = $('#login_name');

    ga('send', 'event', {
        eventCategory: 'Login/Signup',
        eventAction: 'Phone Login Started',
        eventLabel: 'Phone Login Started'
    });

    ga('send', 'event', {
        eventCategory: 'Total Signup',
        eventAction: ' user_registration',
        eventLabel: ' user_registration'
    });

    let params = getLoginUserParams();
    if($.isEmptyObject(params)) return false;

    if(!!recaptcha_token) params['g_recaptcha_response'] = recaptcha_token;
    if (URL_PARAMS.get('recaptcha_bypass_code')) params['recaptcha_bypass_code'] = URL_PARAMS.get('recaptcha_bypass_code');

    if (sendOtpButton.is(':visible')) sendOtpButton.prop('disabled', true).text('Sending OTP');
    $('#mobNumOtp').text(`${params.country_code}-${params.identifier}`);
    userName.prop('disabled', false);

    delete params.countryCodeInt;
    delete params.countryCodeStr;

    mainApiAxios
        .post('/request-otp', params)
        .then(response => response.data)
        .then(response => {
            const otpElm = $(`<input id="login_otp" name="login_otp" class="form-control" type="hidden">`);

            if (response.code === 'OK') {
                // localStorage.setItem('user_type', response.data.code);
                if (!$("#login-form").find("#login_otp").val()) {
                    const username = response.detail_log.user.name;
                    loginStep1.next().trigger('click');
                    if (!!username) userName.val(username).prop('disabled', true);
                }
                otpElm.insertAfter($('#login-form .main_login'));
                sendNewUnverifiedUserNotificationEmail(response.detail_log.user.id);
            }

            if (typeof grecaptcha !== "undefined" && typeof grecaptchaWidgetId1 !== "undefined")
                grecaptcha.reset(grecaptchaWidgetId1);
        })
        .catch(error => {
            let response = error.response.data;
            // if(!!response.message) $('.auth-error').addClass('mt-2').text(response.message).show();
            if(!!response.msg) $('.auth-error').addClass('mt-2').text(response.msg).show();
            if (sendOtpButton.is(':visible')) sendOtpButton.prop('disabled', false).text('Send OTP');
        });
}

window.tabChange = function (val) {
    let ele = document.querySelectorAll('.otp-input-wrapper input');

    if (ele[val - 1].value !== '' && val < 4) {
        ele[val].focus()
    } else if (ele[val - 1].value === '' && val > 1) {
        ele[val - 2].focus()
    }

    /* update OTP input */
    let otpInputs = $('.otp-input-wrapper input');
    let otp1 = otpInputs.eq(0).val();
    let otp2 = otpInputs.eq(1).val();
    let otp3 = otpInputs.eq(2).val();
    let otp4 = otpInputs.eq(3).val();

    let otpStr = '';
    if(!!otp1) otpStr+=otp1;
    if(!!otp2) otpStr+=otp2;
    if(!!otp3) otpStr+=otp3;
    if(!!otp4) otpStr+=otp4;

    $('#login_otp').val(otpStr);

}

window.verifyUser = () => {
    let otp = $('#login_otp').val();
    let name = $('#login_name').val();
    let params = getLoginUserParams();

    if($.isEmptyObject(params)) return false;

    params['otp'] = otp;
    params['name'] = name;

    delete params.countryCodeInt;
    delete params.countryCodeStr;

    mainApiAxios.post('/verify-otp', params)
        .then(response => response.data)
        .then((response) => {
        if (response.code === 'OK') {
            loginSuccess(response);

            ga('send', 'event', {
                eventCategory: 'Total Signup', eventAction: 'user_verified', eventLabel: 'user_verified'
            });

            ga('send', 'event', {
                eventCategory: 'Login/Signup', eventAction: 'Register Success', eventLabel: 'Register Successfully',
                eventValue: schoolType
            });

            schoolTypeRegisterAnalytics(schoolType);
            // getPrefLoc();
            if (window.location.pathname === '/admission/admission-modal.php') location.reload();

        }

    }).catch(err => {
        console.log(err);
        $('.login-form-error').text(`${err.msg}`).show();
        /*if (err.code === 'E_UNAUTHORIZED') {
            $('.login-form-error').text('Incorrect OTP').show();
        } else {
            $('.login-form-error').text('An unknown error occurred.').show();
        }*/
    });
}

window.loginSuccess = (data) => {
    // const payload = jwt_decode(token);
    user = data.detail_log.user;
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('access_token', data.jwt.access_token);
    Cookies.set('access_token_parent', data.jwt.access_token, {domain: DOMAIN_NAME, expires: 30});

    authInit();
    if (user.role.role === 'PARENT') {
        authUiUpdate();
        if (!pageType) updateEventUserId();
        if (pageType && pageType !== 'UAE_DETAILS-PAGE') updateEventUserId();
        if (pageType && pageType === 'UAE_SEARCH') {
            removeBlurLoginSearchPage();
            searchPageLoginAnalytics();
        }
        insertUserAnalytics('login');
        insertUserAnalytics('view', true);
        checkShortlistFixedButton.show();
        if (pageType && pageType === 'UAE_DETAIL_PAGE') {
            blurPreviewDesign();
            // sendVadNotificationProcessing();
            // checkAdmissionAppliedForSchool();
        }

        sendNewVerifiedUserNotificationEmail();

    } else {
        $('.auth-error').addClass('mt-2').text('Invalid user type. Please contact our tech. Support').show();
        logout();
    }
}

window.logout = () => {

    mainApiAxios.post('/parent/logout').then(response => response.data)
        .then((response) => {
            if (response.code === 'OK') {
                console.log('logout successfully');
            }
        })
        .catch(err => {
            console.log(err)
        });

    document.getElementById("login-form").reset();
    access_token = null;
    user = null;
    window.user = user;
    localStorage.removeItem('user');
    localStorage.removeItem('access_token');
    Cookies.remove('access_token_parent', {domain: DOMAIN_NAME});

    // Reset Login Modal
    $('#login-step-1-tab').trigger('click');
    $('.login-action-btn-wrapper button').prop('disabled',false).text('Send OTP');
    $('#login_otp').remove();
    //Google Analytics for Logout User
    ga('send', 'event', {eventCategory: 'Login/Signup', eventAction: 'Logout', eventLabel: 'logout Successfully'});
    // setLoginData();  not necessary
    authUiUpdate();
    // if (pageType && pageType === 'REGISTRATION') location.reload();
    if (typeof(blurPreviewDesign) == 'function') blurPreviewDesign();
}

window.authInit = () => {
    if (!localStorage.getItem('user')) localStorage.removeItem('user');
    access_token = Cookies.get('access_token_parent') || '';
    localStorage.setItem('access_token', access_token);
    if (!localStorage.getItem('user') && access_token) {
        const payload = jwt_decode(access_token);
        localStorage.setItem('user', JSON.stringify(payload.user));
    }
    user = JSON.parse(localStorage.getItem('user'));
    window.user = user;
    console.log(user, 'user');

    if (!access_token) {
        localStorage.removeItem('user');
        user = null;
    }

    setRandomUserId();
    // if (!pageType) updateEventUserId();
    // if (pageType && pageType !== 'DETAILS-PAGE') updateEventUserId();
    authUiUpdate();

    if (access_token) {
        mainApiAxios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
        checkTokenExpired(function (status) {
            if (DEBUG) console.log('checkExpiredToken response', status);
            // if (status && typeof getPrefLoc === "function") getPrefLoc();
            if (status) {
                if (DEBUG) console.log('user logged in Successfully');
                profileUpdate();
                // loadWishlist();
                // goog_report_conversion();
            } else logout();
        });
    }

    openWishlistSidePopup();
}

window.setRandomUserId = () => {
    if (!user && (!localStorage.getItem('userRandomIdentifier') || !Cookies.get('access_token_parent'))) {
        let rendomUserId = `R_${Math.random().toString(36).slice(2)}.${Math.floor(Math.random() * Date.now())}`;
        let userid = localStorage.getItem('userRandomIdentifier') || rendomUserId;
        if (Cookies.get('access_token_parent')) userid = true;

        if(userid.indexOf('R') === -1) userid = rendomUserId;

        localStorage.setItem('userRandomIdentifier', userid);
        Cookies.set('userRandomIdentifier', userid, {domain: DOMAIN_NAME, expires: 15});
    }
}

window.updateEventUserId = () => {
    if (!Cookies.get('userRandomIdentifier') || !user) return;
    let param_setLeadId = '';
    if (typeof setLeadTypeId != 'undefined') param_setLeadId = setLeadTypeId;

    let updateEventUserIdData = new FormData();
    updateEventUserIdData.append('random_userId',Cookies.get('userRandomIdentifier'));
    updateEventUserIdData.append('setLeadTypeId',param_setLeadId);
    updateEventUserIdData.append('client_ip',getSearchParams('client_ip') ?? '');

    mainApiAxios.post(`/update-user-events`, updateEventUserIdData).then(res => {
        console.log(res)
    }).catch(err => console.log(err));
}

window.authUiUpdate = () => {

    if(loginModalElm.is(':visible')){
        loginModalElm.modal('hide');
    }

    if (user) {
        $('.loginUserProfileBlock').show();
        $('.loginBtnBlock').hide();
        // if (mobileCheck()) $('#shortlistHeaderHeartIcon').show();
        // $('#shortlist').show();
        checkShortlistFixedButton.show();
    } else {
        $('.loginUserProfileBlock').hide();
        $('.loginBtnBlock').show();
        $('#shortlistHeaderHeartIcon').hide();
        $('#btn-profile').hide();
        // $('#shortlist').hide();
        checkShortlistFixedButton.hide();
    }
}

window.insertUserAnalytics = (userType, isLogin = false, clickedLink = '') => {

    let refUrl = RefererURL;
    let pageUrl = window.location.pathname + window.location.search;
    let schoolId = (typeof (schoolId) !== "undefined") ? schoolId : null;

    if (userType === 'login') {
        if (Cookies.get('home_page_new') !== undefined) clickedLink = 'v=' + Cookies.get('home_page_new');
    }
    let analyticsPageType = (typeof seoPageType !== 'undefined' && !!seoPageType) ? seoPageType : pageType;

    let userAnalyticsFormData = new FormData();
    userAnalyticsFormData.append('login', isLogin);
    userAnalyticsFormData.append('user_type', userType);
    userAnalyticsFormData.append('rand_id', Cookies.get('userRandomIdentifier'));
    userAnalyticsFormData.append('page_type', analyticsPageType);
    userAnalyticsFormData.append('path', pageUrl);
    if(!!schoolId) userAnalyticsFormData.append('school_id', schoolId);
    userAnalyticsFormData.append('data_text', clickedLink);
    userAnalyticsFormData.append('refer_url', refUrl);
    userAnalyticsFormData.append('ip_address', (typeof IP_ADDRESS !== 'undefined') ? IP_ADDRESS : '');

    mainApiAxios.post(`/update-user-analytics`, userAnalyticsFormData)
        .then(res => console.log(res))
        .catch(err => console.log(err));
}

window.checkTokenExpired = (callback) => {
    mainApiAxios.get('/validate-token').then(res => {
        console.log('checkTokenExpired', res.data.code, res);
        if (callback) callback(true);
    }).catch(err => {
        if (callback) callback(false);
    })
}

window.getSearchParams = (k) => {
    let p = {};
    location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, (s, k, v) => p[k] = v);
    return k ? p[k] : p;
}

window.resetNewLoginForm = () => {
    $('#login-step-1-tab').trigger('click');
    let loginForm = $('#login-form');
    loginForm[0].reset();
    loginForm.find('#login_otp').remove();
    $('#login_otp').val('');
    $('#login-step-1').find("button[type='submit']").text('Send OTP').prop('disabled', false);
}

window.resendLoginOtp = (event) => {

    event.preventDefault();

    if (validateFormLogin('resend')) {

        $('.login-form-error').html("");

        if (typeof grecaptcha !== "undefined" && typeof grecaptchaWidgetId1 !== "undefined")
            grecaptcha.execute(grecaptchaWidgetId1);

        let loginFormResend = $('.login-form-resend');
        loginFormResend.empty();
        setTimeout(() => loginFormResend.html('OTP sent again successfully <br/>'), 1000);

    } else {

        let loginFormErrorElm = $('.login-form-error');
        if (!loginFormErrorElm.html()) {
            if (!$('#login_name').val()) loginFormErrorElm.append("Name is required.<br/>");
            if (!loginPhone.val()) loginFormErrorElm.append("Phone number is required.<br/>");
        }

    }
}

window.schoolTypeRegisterAnalytics = (schoolType) => {
    let schTypeArr = [
        {id: 1, text: "Day School"},
        {id: 2, text: "Play School"},
        {id: 3, text: "Boarding School"},
        {id: 4, text: "Boarding School"}
    ];

    let {text = ""} = schTypeArr.find(({id = 0}) => id === parseInt(schoolType)) || {};

    ga('send', 'event', {
        eventCategory: 'Login/Signup', eventAction: `${text} Register Success`,
        eventLabel: `${text} Register Successfully`
    });
}

window.getLoginUserParams = () => {

    const COUNTRY_CODE_INT = loginPhone.intlTelInput("getSelectedCountryData").dialCode.replace('+', '');
    const COUNTRY_CODE_STR = loginPhone.intlTelInput("getSelectedCountryData").iso2;
    let loginFormError = $('.login-form-mobile-error');
    let phone = loginPhone.val().replace(/ /g, '');
    if (phone.split('')[0] === "0") phone = phone.replace('0', '');
    if (COUNTRY_CODE_INT === '91' && phone.length > 10) if (phone.slice(0, 2) === '91') phone = phone.replace('91', '');
    //phone = COUNTRY_CODE_INT === '91' ? phone : `${COUNTRY_CODE_INT}-${phone}`;
    let otp = $('#login_otp');
    let rndId = Cookies.get("userRandomIdentifier");

    let params = {
        identifier: phone,
        role: 1,
        // email: '',
        // randomId: rndId,
        // countryCodeStr: COUNTRY_CODE_STR,
        country_code: COUNTRY_CODE_INT
    };

    let validatePhoneFromScript = verifyPhoneNumberFromGoogleScript(phone, COUNTRY_CODE_STR);

    if(!validatePhoneFromScript){
        loginFormError.text("Phone number is invalid.");
        params = {};
    }else{
        loginFormError.text();
    }

    console.log(params, COUNTRY_CODE_STR, validatePhoneFromScript);
    return params;
}

function openWishlistSidePopup() {
    if (window.location.href.indexOf('shortlist') > -1) {
        if (pageType && pageType === 'UAE_HOME') {
            if (user && !tokenExpired) {
                loadWishlist();
                $('#ShortlistModal').modal('show');
                wishlistModalOpenAnalytics();
            } else {
                if (tokenExpired) {
                    toastr.error('', 'Your link has expired, Please login again or contact us', {
                        "positionClass": "toast-top-center",
                        "showDuration": "5000",
                        "hideDuration": "5000"});
                }
                logout();
                loginModalElm.modal('show', {backdrop: 'static', keyboard: false});
            }
        }else{
            if(user) loadWishlist();
        }
    }else{
        if(user) loadWishlist();
    }
}

$(function() {

    /* ======================= login form - modal ======================= */
    if(modalLoginForm.length){
        modalLoginForm.on("submit", function (event) {
            event.preventDefault();
            if (validateFormLogin('submit')) {

                if($('#login-step-1').hasClass('show')) {
                    grecaptcha.execute(grecaptchaWidgetId1);
                }
                else if ($('#login_otp').val().length === 4){
                    verifyUser();
                }

            } else {

                let loginFormErrorElm = $('.login-form-error');
                $('.login-form-resend').empty();
                if (!loginFormErrorElm.html()) {
                    if (!$('#login_name').val()) loginFormErrorElm.append("Name is required.<br/>");
                    if (!loginPhone.val()) loginFormErrorElm.append("Phone number is required.<br/>");

                    if (!$('#login_otp').val().length) {
                        loginFormErrorElm.append("OTP is required.<br/>");
                    }
                }
            }
        });
    }
    /* ======================= /login form - modal ======================= */

    /* ======================= login actions - modal ======================= */
    authInit();
    /* ======================= /login actions - modal ======================= */

    /* ======================= add country code Input ======================= */
    $('#loginModal').on('show.bs.modal', () => {
        let loginUserMobile = $('.login-user-mobile');

        if(loginUserMobile.parent('.iti').length === 0){
            loginUserMobile.intlTelInput(defaultIntlTelInput);
        }
    });
    /* ======================= /add country code Input ======================= */

});
